// Copyright (c) 2022 Celadon Development LLC, All rights reserved.
// Author Alexander Mikholap <alexander.mikholap@celadon.ae>
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import uuidv4 from 'uuid/v4';

import { withStyles } from '@material-ui/core/styles';
import {
  Loader,
  Voucher,
} from '../../../../../../../../components';

import styles from './styles';


class ResultVouchersContainer extends Component {
  state = {};

  static propTypes = {
    classes: PropTypes.object,
    loading: PropTypes.bool,
    vouchers: PropTypes.array,
  };

  static defaultProps = {
    classes: {},
    loading: false,
    vouchers: [],
  };

  renderContent = () => {
    const {
      classes,
      vouchers,
    } = this.props;

    return (
      <div className={classes.container}>
        {Array.from(vouchers).map(voucher => (
          <Voucher
            key={uuidv4()}
            voucher={voucher}
          />
        ))}
      </div>
    );
  }

  render() {
    const {
      classes,
      loading,
      vouchers,
    } = this.props;

    return loading
      ? (
        <div className={classes.loaderContainer}>
          <Loader />
        </div>
      ) : (vouchers.length !== 0 && this.renderContent());
  }
}

export default (withStyles(styles)(ResultVouchersContainer));
